import React from 'react';
import { Transition, animated } from 'react-spring';
import { Message } from '@tomis-tech/types';

import { useParent } from '../context';
import { mainButtonSize } from '../consts';
import MessageContent from './MessageContent';
import { processDialogflowMessage } from '../utils';

const inStyles = {
  opacity: 1,
  transform: 'translateX(0px)',
};
const outStyles = {
  opacity: 0,
  transform: 'translateX(15px)',
};

interface LatestMessagePreviewProps {
  showPreview: boolean;
  latestImportantMessage: Message;
  settlePosition: () => void;
  onClick: () => void;
}

const LatestMessagePreview: React.FC<LatestMessagePreviewProps> = React.memo(
  ({ showPreview, latestImportantMessage, settlePosition, onClick }) => {
    const { isMobile } = useParent();

    const { textMessages } = processDialogflowMessage(latestImportantMessage);

    return (
      <Transition
        native
        config={{ tension: 320, friction: 12 }}
        items={showPreview}
        update={{ isMobile }}
        from={outStyles}
        enter={inStyles}
        leave={outStyles}
        onRest={settlePosition}
      >
        {show =>
          show &&
          (containerStyle => (
            <animated.div
              style={containerStyle}
              css={(theme: Theme) => ({
                position: 'absolute',
                bottom: theme.widget.closedSpace,
                right: theme.widget.closedSpace,
                left: 0,
                height: mainButtonSize,
                marginRight: mainButtonSize + theme.widget.padding * 1.5,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              })}
            >
              <button
                onClick={onClick}
                css={(theme: Theme) => ({
                  display: 'block',
                  position: 'relative',
                  maxHeight: '100%',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  textAlign: 'left',
                  boxShadow: theme.shadows.widget,
                  background: 'white',
                  padding: theme.widget.padding,
                  border: 'none',
                  borderRadius: 4,
                  fontSize: isMobile ? 13 : 14,
                  lineHeight: 1.25,
                })}
              >
                <MessageContent>{textMessages[0]}</MessageContent>
                <div
                  css={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 20,
                    background:
                      'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 90%)',
                  }}
                />
              </button>
              <div
                css={{
                  position: 'absolute',
                  left: '100%',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderStyle: 'solid',
                  borderWidth: '8px 0 8px 8px',
                  borderColor: 'transparent transparent transparent #ffffff',
                }}
              />
            </animated.div>
          ))
        }
      </Transition>
    );
  }
);

export default LatestMessagePreview;
